export default "__VITE_ASSET__B4IQf9v8__"